<template>
  <div class="manage">

    <el-dialog
      :title="dialogForm.type === 'add' ? '新增手记车数' : '更新手记车数'"
      :visible.sync="dialogForm.isShow"
      @close="  closeDia"
    >
      <el-form ref="dialogForm" label-width="150px" :model="dialogForm.formData" size="mini" :rules="dialogForm.rules">
        <el-form-item label="车辆编号" label-width="140px" style="width: 340px" prop="code">
          <el-input
            placeholder="请输入车辆编号"
            v-model.trim="dialogForm.formData.code"
          />
        </el-form-item>
        <el-form-item label="人工计数生产数量" label-width="140px" style="width: 340px" prop="count">
          <el-input-number
            placeholder="输入车数"
            v-model.trim="dialogForm.formData.count"
          />
        </el-form-item>
        <el-form-item label="生产日期" label-width="140px" style="width: 340px" prop="productionTime">
          <el-date-picker v-model="dialogForm.formData.productionTime" placeholder="请选择生产日期" type="datetime"/>
        </el-form-item>
        <el-form-item>
          <el-radio-group v-model="radio" @input="changeRadio">
            <el-radio label="白班" border/>
            <el-radio label="夜班" border/>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="备注" label-width="140px" style="width: 340px" prop="remark">
          <el-input type="textarea" :autosize="{ minRows: 2, maxRows: 4}"
                    v-model.trim="dialogForm.formData.remark"
                    maxlength="100"
                    show-word-limit style="width:100%"/>
        </el-form-item>
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogForm.isShow = false">取消</el-button>
        <el-button type="primary" @click="confirm">确定</el-button>
      </div>
    </el-dialog>
    <!--操作-->
    <div style="margin-bottom: 10px">
      <!--      <el-upload :action="importApi" :headers="headers" accept="xlsx" :show-file-list="false"-->
      <!--                 :on-success="handleImportSuccess" :multiple="false"-->
      <!--                 style="display:inline-block">-->
      <!--        <el-button type="success" size="mini"-->
      <!--        >导入 <i class="el-icon-bottom"></i>-->
      <!--        </el-button>-->
      <!--      </el-upload>-->
      <!--      <el-button type="warning" size="mini" @click="exportData" style="margin-left: 10px"-->
      <!--      >导出 <i class="el-icon-top"></i>-->
      <!--      </el-button>-->
      <el-button type="primary" @click="handleAdd" size="mini"
      >新增 <i class="el-icon-circle-plus-outline"></i>
      </el-button>
    </div>
    <!------------------------- 搜索 -------------------------------->
    <div class="manage-header">
      <el-form label-width="auto" :model="searchForm.formData"
               :inline="true" size="mini">
        <el-form-item label="车辆编号" prop="code">
          <el-input
            placeholder="请输入车辆编号"
            v-model.trim="searchForm.formData.code"
            prefix-icon="el-icon-search"
          />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="search" size="mini">搜索 <i class="el-icon-search"/></el-button>
          <el-button type="danger" @click="reset" size="mini">重置 <i class="el-icon-refresh-left"/></el-button>
        </el-form-item>
      </el-form>
    </div>
    <!------------------------ 数据表格 ----------------------->
    <div class="common-table">
      <el-table
        :data="table.tableData"
        height="85%"
        border
        stripe
        row-key="id"
        :header-cell-style="{background: '#eef1f6',color: '#606266',
        textAlign:'center',fontWeight:'bold',borderWidth:'3px'}"
      >
        <el-table-column prop="code" label="车辆编号" min-width="80" align="center">
          <template slot-scope="{ row }">
            <div style="min-height: 63px; display: flex; justify-content: center; align-items: center;">
              {{ row.code }}
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="count" label="人工计数生产数量(单位：车)" min-width="80" align="center" />
        <el-table-column prop="productionTime" label="生产时间" min-width="125" align="center"/>
        <el-table-column prop="createTime" label="创建时间" min-width="125" align="center"/>
<!--        <el-table-column prop="updateTime" label="修改时间" min-width="180" align="center"/>-->
        <el-table-column prop="remark" label="备注" width="200" align="center"/>
        <el-table-column label="操作" width="190" fixed="right" align="center">
          <template slot-scope="scope">
            <div style="min-height: 63px; display: flex; justify-content: center; align-items: center;">
              <el-button size="mini" type="primary" @click="editAdd(scope.row)">修改 <i class="el-icon-edit"></i></el-button>
              <el-popconfirm
                style="margin-left:10px;margin-right:10px"
                confirm-button-text='确定'
                cancel-button-text='我再想想'
                icon="el-icon-info"
                icon-color="red"
                title="你确定删除吗？"
                @confirm="deleteAdd(scope.row.id)"
              >
                <el-button size="mini" type="danger" slot="reference">删除 <i class="el-icon-remove-outline"></i></el-button>
              </el-popconfirm>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        class="pager"
        layout="total,sizes,prev,pager,next,jumper"
        :page-size="table.pageConfig.size ? table.pageConfig.size : 10"
        :page-sizes="[5, 10, 15, 20]"
        :total="table.pageConfig.total"
        :current-page.sync="table.pageConfig.current"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      ></el-pagination>
    </div>
  </div>
</template>
<script>
import {getListAdd, add, deleteOne, edit} from '@/api/production'

export default {
  name: 'Add',
  data () {
    return {
      radio: '',
      table: {
        tableData: [],
        pageConfig: {
          total: 10, // 记录总数
          current: 1, // 起始页
          size: 10 // 每页展示的记录数
        }
      },
      searchForm: {
        deptList: [],
        formData: {}
      },
      dialogForm: {
        type: 'add', // add为新增，edit为编辑
        isShow: false,
        formData: {}
        // rules: {
        //   // typeNum: [
        //   //   { required: true, message: '请选择', trigger: 'change' }
        //   // ],
        //   name: [
        //     { required: true, message: '请输入姓名', trigger: 'blur' }
        //   ],
        //   idCard: [
        //     { required: true, message: '请输入身份证号', trigger: 'blur' }
        //   ],
        //   startDate: [
        //     { required: true, message: '请选择开始日期', trigger: 'blur' }
        //   ],
        //   days: [
        //     { required: true, message: '请输入请假天数', trigger: 'blur' }
        //   ]
        // }
      }
    }
  },
  created () {
    this.loading()
  },
  methods: {
    formatDateToYYYYMMDDHHMMSS (date1) {
      const date = new Date(date1)
      const year = date.getFullYear()
      const month = String(date.getMonth() + 1).padStart(2, '0')
      const day = String(date.getDate()).padStart(2, '0')
      const hours = String(date.getHours()).padStart(2, '0')
      const minutes = String(date.getMinutes()).padStart(2, '0')
      const seconds = String(date.getSeconds()).padStart(2, '0')

      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`
    },
    closeDia() {
      this.radio = ''
    },
    changeRadio(e) {
      if (this.dialogForm.formData.productionTime === undefined) {
        this.radio = ''
        this.$message({
          message: '请先选择日期！',
          type: 'warning'
        });
        return
      }
      if (e === '白班') {
        this.dialogForm.formData.productionTime = this.formatDateToYYYYMMDDHHMMSS(new Date(this.dialogForm.formData.productionTime).setHours(12, 0, 0))
      } else {
        this.dialogForm.formData.productionTime = this.formatDateToYYYYMMDDHHMMSS(new Date(this.dialogForm.formData.productionTime).setHours(23, 0, 0))
      }
    },
    editAdd(row) {
      this.dialogForm.isShow = true
      this.dialogForm.type = 'edit'
      this.dialogForm.formData = row
    },
    deleteAdd(id) {
      deleteOne(id).then((res) => {
        if (res.code === 200) {
          this.$message.success('删除成功！')
          this.loading()
        } else {
          this.$message.error('删除失败！')
        }
      })
    },
    loading () {
      getListAdd({
        current: this.table.pageConfig.current,
        size: this.table.pageConfig.size,
        code: this.searchForm.formData.code,
        deptId: this.$store.state.staff.staff.deptId
      }).then(response => {
        if (response.code === 200) {
          this.table.tableData = response.data.list
          this.table.pageConfig.total = response.data.total
          this.totalCount = response.data.totalCount
        } else {
          this.$message.error(response.message)
        }
      })
    },
    confirm () {
      this.dialogForm.formData.deptId = this.$store.state.staff.staff.deptId
      if (this.dialogForm.type === 'add') {
        add(this.dialogForm.formData).then(response => {
          if (response.code === 200) {
            this.$message.success('提交成功！')
            this.dialogForm.isShow = false
            this.loading()
          } else {
            this.$message.error('提交失败')
          }
        })
      } else {
        edit(this.dialogForm.formData).then((response) => {
          if (response.code === 200) {
            this.$message.success('修改成功！')
            this.dialogForm.isShow = false
            this.loading()
          } else {
            this.$message.error('修改失败！')
          }
        })
      }
    },
    handleAdd () {
      this.showIdCard = true
      this.dialogForm.isShow = true
      this.dialogForm.type = 'add'
      this.dialogForm.formData = {}
    },
    search () {
      this.loading()
    },
    // 重置搜索表单
    reset () {
      this.searchForm.formData = {}
      this.loading()
    },
    handleSizeChange (size) {
      this.table.pageConfig.size = size
      this.loading()
    },
    handleCurrentChange (current) {
      this.table.pageConfig.current = current
      this.loading()
    }
  }
}
</script>
